export default "__VITE_ASSET__Dg$KO0xV__"